module.exports = __webpack_public_path__ + "media/images/line-4c9da8eb22ab6cd4fde87f9c156bfab3.svg";